// Application React DOM Mount Entry Point
// This file initializes React and mounts the application onto the DOM container node '#root' inside index.html.

import React from "react";
import ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { ConvexClerkProvider } from "@/providers/ConvexClerkProvider";
import "@/styles/index.css";

// Retrieve the base DOM node container to render the application.
const container = document.getElementById("root");

// Assert container presence to avoid mounting errors in the browser.
if (!container) {
  throw new Error("Unable to locate mount container #root in the host HTML body.");
}

// Render the application.
// - StrictMode warns about legacy API usage or side-effects during development.
// - ConvexClerkProvider enables Convex state management with Clerk auth.
// - BrowserRouter enables route matching within the React application.
ReactDOMClient.createRoot(container).render(
  <React.StrictMode>
    <ConvexClerkProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConvexClerkProvider>
  </React.StrictMode>
);
